import { SpriteDefinition } from '../types/sprites';

export const SPRITE_REGISTRY: Record<string, SpriteDefinition> = {
  // Kim Variations
  k1_kim_base: {
    key: "k1_kim_base",
    atlas: "k1_kim_with_clothing_and_weapons",
    frame: "k1_kim_with_clothing_and_weapons_0001",
    animation: {
      prefix: "k1_kim_with_clothing_and_weapons_",
      start: 1,
      end: 34,
      zeroPad: 4,
      frameRate: 12,
      repeat: -1
    }
  },

  // Supreme Court (Justice samples) - using supreme_court_spritesheet
  john_roberts_idle: {
    key: "john_roberts_idle",
    atlas: "supreme_court_spritesheet",
    frame: "supreme_court_spritesheet_0001"
  },
  sonia_sotomayor_idle: {
    key: "sonia_sotomayor_idle",
    atlas: "supreme_court_spritesheet",
    frame: "supreme_court_spritesheet_0025"
  }
};
